import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock } from "vue"

import Lesson from "@/components/lesson/Lesson.vue";

export default /*#__PURE__*/_defineComponent({
  __name: 'LessonPage',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(Lesson))
}
}

})